(function () {
  const toc = document.querySelector(".js-toc");
  if (!toc) return;

  const content = document.querySelector(".js-article-content");
  if (!content) return;

  const EXTRA_SELECTOR = ".js-toc-heading";

  const headings = content.querySelectorAll(`h2, h3, ${EXTRA_SELECTOR}`);

  if (!headings.length) {
    toc.remove();
    return;
  }

  // 目次を最初のH2の手前に移動
  const firstH2 = content.querySelector("h2");
  if (firstH2) {
    firstH2.before(toc);
  }

  const slugify = (text) =>
    text
      .trim()
      .toLowerCase()
      .replace(/[^\w\u3040-\u30ff\u3400-\u9fff]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

  const used = new Map();
  const uniqueId = (base) => {
    const n = used.get(base) || 0;
    used.set(base, n + 1);
    return n === 0 ? base : `${base}-${n + 1}`;
  };

  const ul = document.createElement("ul");
  ul.className = "toc__list";

  headings.forEach((el) => {
    const text = (el.textContent || "").trim();
    if (!text) return;

    if (!el.id) {
      const base = slugify(text) || "section";
      el.id = uniqueId(base);
    }

    const tag = el.tagName.toLowerCase();
    const levelClass =
      tag === "h2" ? "h2" : tag === "h3" ? "h3" : "custom";

    const li = document.createElement("li");
    li.className = `toc__item toc__item--${levelClass}`;

    const a = document.createElement("a");
    a.className = "toc__link";
    a.href = `#${el.id}`;
    a.textContent = text;

    a.addEventListener("click", (e) => {
      e.preventDefault();
      document
        .getElementById(el.id)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
      history.replaceState(null, "", `#${el.id}`);
    });

    li.appendChild(a);
    ul.appendChild(li);
  });

  toc.appendChild(ul);
})();

//  FAQ処理用-------------------------
(function () {
  const content = document.querySelector(".js-article-content");
  if (!content) return;

  const headings = content.querySelectorAll("h2");
  let faqHeading = null;

  headings.forEach((heading) => {
    const text = (heading.textContent || "").replace(/\s+/g, "").trim();

    if (text.includes("よくあるご質問")) {
      faqHeading = heading;
    }
  });

  if (!faqHeading) return;

  const faqItems = [];
  let currentQuestion = null;

  let element = faqHeading.nextElementSibling;

  while (element) {
    if (element.tagName && element.tagName.toLowerCase() === "h2") break;

    const text = (element.textContent || "").replace(/\s+/g, " ").trim();

    if (text.startsWith("Q.")) {
      currentQuestion = text.replace(/^Q\.\s*/, "").trim();
    }

    if (text.startsWith("A.") && currentQuestion) {
      const answer = text.replace(/^A\.\s*/, "").trim();

      faqItems.push({
        "@type": "Question",
        "name": currentQuestion,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer
        }
      });

      currentQuestion = null;
    }

    element = element.nextElementSibling;
  }

  if (!faqItems.length) return;

  // すでにFAQPageのJSON-LDがある場合は重複生成しない
  const existingJsonLdScripts = document.querySelectorAll(
    'script[type="application/ld+json"]'
  );

  const hasFaqSchema = Array.from(existingJsonLdScripts).some((script) => {
    try {
      const data = JSON.parse(script.textContent);
      return data["@type"] === "FAQPage";
    } catch (e) {
      return false;
    }
  });

  if (hasFaqSchema) return;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems
  };

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(faqSchema);
  document.head.appendChild(script);
})();